/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'square': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M3 3v18h18V3"/>'
  }
})
